'use strict';

/*global services*/
/*global K2ApplicationSpecial*/
/*global reloadQueuePage*/

var app = null;

function deInitialize($wrapper) {
  $wrapper.find('.k2-keyboard-input').removeClass('keyboard-init');
}

function disableRightClick($wrapper) {
  var blockContextMenu = function (evt) {
    evt.preventDefault();
  };

  $wrapper.on('contextmenu', blockContextMenu);
}

function initialize($wrapper, withDeInitialize) {
  if (withDeInitialize) {
    deInitialize($wrapper);
  }

  $wrapper.find('.js-datepicker').each(function () {
    var $input = $(this);
    $input.datepicker({ language: services.get('configurations').param('locale'), autoclose: true, todayBtn: 'linked', todayHighlight: true, format: 'dd.mm.yyyy' });

    $input.inputmask({ alias: 'dd.mm.yyyy' });
  });

  $wrapper.find('.js-clockpicker').each(function () {
    var $input = $(this);

    $input.clockpicker({ autoclose: true, default: 'now' });
    $input.inputmask({ alias: 'hh:mm' });
  });

  $wrapper.find('form').k2_filterClear();
  $wrapper.find('.alert-fs').k2_alerts({ autoCloseTimeout: services.get('configurations').param('alert_auto_close_timeout'), autoCloseAlerts: ['success', 'warning'] });
  $wrapper.find('.panel-collapsible').k2_panelCollapsible();
  $wrapper.find('.reload-page-countdown').k2_countdown({ duration: services.get('configurations').param('reload_page_interval'), callback: reloadQueuePage, repeat: true });
  $wrapper.find('.k2-keyboard-input').k2_keyboard_input();
  $wrapper.find('.k2-keyboard-input--lazy-open').k2_keyboard_input({ openAfterFocus: false, enabledSpace: true });
  $wrapper.find('.table-hover').k2_tableFixedHover();
  $wrapper.find('.autofocus').k2_autofocus();
  $wrapper.find('.help-box').k2_helpBox();
}

$(document).ready(function () {
  app = new K2ApplicationSpecial(services);

  initialize($('body'));

  if (app.param('disabled_right_click')) {
    disableRightClick($('html'));
  }

  $().k2_top();
});
